module.exports = __webpack_public_path__ + "img/bitrix24-logo.98adfd4c.svg";